/**
 * Read an object from Web Storage without allowing unavailable, malformed, or
 * legacy primitive values to prevent the frontend from starting.
 */
export function readStoredObject(storageOrGetter, key) {
  try {
    // Accessing `window.localStorage` can itself throw a SecurityError when a
    // browser disables storage. Accept a getter so that access happens inside
    // this boundary instead of while a caller evaluates its arguments.
    const storage = typeof storageOrGetter === 'function'
      ? storageOrGetter()
      : storageOrGetter
    const raw = storage.getItem(key)
    if (!raw) return null

    const value = JSON.parse(raw)
    return value && typeof value === 'object' && !Array.isArray(value) ? value : null
  } catch {
    return null
  }
}
